export const Resource = {
  CPU_CORE: 'cpu_core',
  EDGE_COMPACT: 'edge_compact',
  EDGE_COMPACT_HA: 'edge_compact_ha',
  EDGE_LARGE: 'edge_large',
  EDGE_LARGE_HA: 'edge_large_ha',
  EDGE_QUAD: 'edge_quad',
  EDGE_QUAD_HA: 'edge_quad_ha',
  EDGE_X: 'edge_x',
  EDGE_X_HA: 'edge_x_ha',
  ISOLATED_NETWORK: 'isolated_network',
  PROTECTED_SUBNET_24: 'protected_subnet_24',
  PROTECTED_SUBNET_25: 'protected_subnet_25',
  PROTECTED_SUBNET_26: 'protected_subnet_26',
  PROTECTED_SUBNET_27: 'protected_subnet_27',
  PROTECTED_SUBNET_28: 'protected_subnet_28',
  PROTECTED_SUBNET_29: 'protected_subnet_29',
  PROTECTED_SUBNET_32: 'protected_subnet_32',
  RAM: 'ram',
  STORAGE: 'storage',
  STORAGE_FAST_VHDD: 'storage_fast_vhdd',
  STORAGE_FAST_VSSD: 'storage_fast_vssd',
  STORAGE_ULTRA_VSSD: 'storage_ultra_vssd',
  STORAGE_S_213A_960: 'storage_s-213a-960',
  STORAGE_VHDD: 'storage_vhdd',
  STORAGE_VSSD: 'storage_vssd',
  SUBNET_24: 'subnet_24',
  SUBNET_25: 'subnet_25',
  SUBNET_26: 'subnet_26',
  SUBNET_27: 'subnet_27',
  SUBNET_28: 'subnet_28',
  SUBNET_29: 'subnet_29',
  SUBNET_32: 'subnet_32',
  VBR_BACKUPS_CNT: 'vbr_backups_cnt',
  VBR_BACKUPS_STORAGE: 'vbr_backups_storage',
  WINDOWS_CORE: 'windows_core'
}

export const Group = {
  SPB_GOLD_1_DR: 'eacbc41e-8809-4b6d-876a-84022924986a',
  SPB_GOLD_1: '91192387-5a7c-4d58-9721-b5f460f84cae',
  SPB_SILVER_1:	'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
  MSK_GOLD_1DR:	'a20baaef-4e9e-4686-9aee-231957268f95',
  MSK_GOLD_1:	'2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
  MSK_SILVER_1:	'510a08cc-da48-4d98-b84b-b60d21f15b5b',
  MSK_PLATINUM: 'f23f12dc-e993-41c6-afba-58ba43d31f8a'
}